(function () {
  function openExpoFormPopup() {
    document.body.classList.add('expo-form-popup-show');
  }

  function closeExpoFormPopup() {
    document.body.classList.remove('expo-form-popup-show');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);

    if (params.get('popup') === 'expo-form') {
      openExpoFormPopup();
    }

    var popup = document.querySelector('[data-expo-form-popup]');

    if (!popup) {
      return;
    }

    var closeBtn = popup.querySelector('[data-close-expo-form]');

    if (closeBtn) {
      closeBtn.addEventListener('click', closeExpoFormPopup);
    }

    document.addEventListener('click', function (event) {
      if (
        document.body.classList.contains('expo-form-popup-show') &&
        !popup.contains(event.target)
      ) {
        closeExpoFormPopup();
      }
    });
  });
})();
